export const USER_ANALYTICS = 'user_analytics';
export const USER_MANAGEMENT = 'user_management';
